import React from "react";

// Customizable Area Start
import { TextField, Button, Typography, Box } from '@mui/material';
import { logo, sideImg } from "./assets";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// Customizable Area End

import OTPInputAuthController, {
  Props,
} from "./OTPInputAuthController";

export default class OTPInputAuth extends OTPInputAuthController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start
  // Customizable Area End

  render() {
    return (
      // Customizable Area Start
      <div style={{ display: 'flex', width: '100%', height: '100vh' }}>
        <div style={{ flex: 1, padding: '32px', position: 'relative' }}>
          <img onClick={(e) => {
            e.stopPropagation();
            this.props.navigation.navigate('LandingPage');
          }}
            src={logo} alt="logo" style={{ width: '148px', height: '24px', marginBottom: '20px' }} />

          <div style={{ width: '48px', height: '48px', cursor: 'pointer', marginBottom: '20px' }}
            data-test-id="btnBack"
            onClick={this.handleBack}>
            <ArrowBackIcon style={{ width: '100%', height: '100%' }} />
          </div>

          <div style={{ maxWidth: '327px', margin: '0 auto', marginTop: '80px', textAlign: 'center' }}>
            <Typography variant="h5" sx={{ fontSize: '22px', fontWeight: 700, color: '#10100f', lineHeight: '22px', marginBottom: '30px' }}>
              OTP Verification
            </Typography>
            <Typography variant="body1" sx={{ fontSize: '14px', fontWeight: 400, color: '#10100f', lineHeight: '22px', marginBottom: '35px' }}>
              Enter the verification code sent to {`***${this.state.number?.slice(-2)}`}
            </Typography>

            <div style={{ display: 'flex', gap: '27px', justifyContent: 'center', marginBottom: '40px', }}>
              {[0, 1, 2, 3].map((index) => (
                <TextField
                  data-index={index}
                  key={index}
                  inputRef={this.state.inputRefs[index]}
                  variant="outlined"
                  inputProps={{
                    maxLength: 1,
                    sx: {
                      height: '100%',
                      padding: 0,
                      boxSizing: 'border-box',
                      textAlign: 'center',
                    },
                  }}
                  sx={{
                    width: 60,
                    height: 60,
                    '& .MuiOutlinedInput-root': {
                      padding: 0,
                      height: '100%',
                      border: this.state.otpError ? '1px solid #DC2626' : '1px solid black',
                      borderRadius: '8px'
                    },
                  }}
                  value={this.state.otpValues[index]}
                  onChange={(e) => this.handleOTPChange(index, e.target.value)}
                  onKeyDown={(e) => this.handleKeyDown(index, e)}
                />
              ))}
            </div>

            {this.state.otpError ? (
              <Typography sx={{ font: 'Inter', fontSize: '14px', fontWeight: 400, color: '#DC2626', lineHeight: '22px', marginBottom: '11px', marginTop: '-20px' }}>
                {this.state.otpError}
              </Typography>
            ) : null}

            <Button
              data-test-id="btnVerify"
              variant="contained"
              sx={{
                font: 'Inter',
                width: '100%',
                height: '56px',
                backgroundColor: this.state.isVerifyDisabled ? '#f1f5f9' : '#000000',
                borderRadius: '8px',
                color: this.state.isVerifyDisabled ? '#64748b' : '#ffffff',
                fontSize: '16px',
                fontWeight: 700,
                cursor: this.state.isVerifyDisabled ? 'not-allowed' : 'pointer',
                marginBottom: '11px',
                transition: 'background-color 0.3s',
                textTransform: 'none',
                '&:hover': {
                  backgroundColor: this.state.isVerifyDisabled ? '#f1f5f9' : '#000000',
                },
              }}
              onClick={() => {
                this.handleVerify();
              }}
              disabled={this.state.isVerifyDisabled}
            >
              Verify
            </Button>
            <Typography variant="body2" sx={{ fontSize: '14px', fontWeight: 400, color: '#000000', lineHeight: '22px' }}>
              Didn't receive an OTP?&nbsp;
              <span
                data-test-id = "resendButton"
                style={{ cursor: 'pointer' }}
                onClick={() => this.handleResendOTP()}
              >
                {this.state.timer > 0 ? `Resend in 0:${this.state.timer.toString().padStart(2, '0')} seconds` : 'Resend'}
              </span>
            </Typography>
          </div>
        </div>

        <Box sx={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          maxWidth: '50%',
          position: 'relative'
        }}>
          <img src={sideImg} alt="background" style={{ width: '100%', height: '100%' }} />
          <Box sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundImage: `linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0))`
          }} />
        </Box>
      </div>
      // Customizable Area End
    );
  }
}

// Customizable Area Start
// Customizable Area End